import { buildMikasaClient } from '../../helpers/api'

export const getChromeBotClientEvents = async authSettings => {
  const client = await buildMikasaClient(authSettings)

  const response = await client.get('/chromebot/client_events')

  return response?.data
}
